<template>
 <div >
       <v-toolbar dense style="background:royalblue;color:white;font-weight:bold">
     Inquiry Report
    <v-spacer></v-spacer>
    <v-toolbar-items>
       <download-excel
            :data="table"
            name="Inquiry.xls"
            :fields="fields" style="height:30px;margin-top:9px;margin-right:10px">
            <v-btn class="success" small>Export</v-btn>
        </download-excel>
    <input type="number" slot="activator" style="color:black;margin-top:7px"  v-model="phone" class="search" placeholder="Enter Phone" >
    <v-btn class="success searchbtn" style="height:34px;margin-left:10px" @click="fetchstatement"> Search</v-btn>
    </v-toolbar-items>
  </v-toolbar>
        <v-card >
        <v-data-table
            :headers="headers"
            :items="table"
            hide-actions
            :search="search"
            :loading="loading"
            >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" >
                <td :style="{background:getbackground(props.item.status)}">{{ props.item.orderno }}</td>
                <td :style="{background:getbackground(props.item.status)}">{{ props.item.service }}</td>
                <td :style="{background:getbackground(props.item.status)}">{{ props.item.mobile }}</td>
                <td :style="{background:getbackground(props.item.status)}">{{ props.item.amount }}</td>
                <td :style="{background:getbackground(props.item.status)}"> <v-btn small :class="checkstatus(props.item.status)" style="width:100%"> {{  props.item.status }}</v-btn></td>
                <td :style="{background:getbackground(props.item.status)}">{{ props.item.tid }}</td>
                <td :style="{background:getbackground(props.item.status)}">{{ props.item.type }}</td>
                <td :style="{background:getbackground(props.item.status)}">{{ props.item.openbalance }}</td>
                <td :style="{background:getbackground(props.item.status)}">{{ props.item.closebalance }}</td>
                <td :style="{background:getbackground(props.item.status)}">{{ props.item.com }}</td>
                <td :style="{background:getbackground(props.item.status)}">{{ props.item.surcharge }}</td>
                <td :style="{background:getbackground(props.item.status)}">{{ new Date(parseInt(props.item.time)) | moment("DD-MM-YYYY, h:mm:ss a")}}</td>
                <td :style="{background:getbackground(props.item.status)}" > <v-btn small style="width:100%" v-if="props.item.status.toLowerCase()!='fail'" @click="openremark(props.item)" class="warning"> Complaint</v-btn></td>
                <td :style="{background:getbackground(props.item.status)}"  > <v-btn small  style="width:100%"   class="primary">Print</v-btn></td>
            </template>      
            </v-data-table>   
                </v-card>
      <Progress v-if="progress"/>
      <Preview v-if="preview" :data="data" :params="params"/>
      <Message v-if="message" :res="response"/>
      <Complaint v-if="complaint" :id="tid"/>
  </div>
</template>

<script>
import Progress from '../components/Progress.vue'
import Preview from '../components/Preview.vue'
import Message from '../components/Message.vue'

import Complaint from '../components/Complaint.vue'

export default {
    components:{
        Progress,
        Preview,
        Message,
        Complaint
    },
    data(){
        return{
            way:'prepaid',
            loading:false,
            data:[],
            progress:false,
            preview:false,
            message:false,
            response:"",
            params:"",
            search:'',
            type:"BP",
            phone:'',
            tid:'',
            pagination: {},
            complaint:false,
            fields:{
                'Recharge ID':'orderno' ,
                'Service': 'service' ,
                'MobileNo': 'mobile' ,
                'Amount': 'amount' ,
                'Status': 'status' ,
                'Transaction ID': 'tid' ,
                'Type': 'type' ,
                'Opening Balance': 'openbalance' ,
                'Closing Balance': 'closebalance' ,
                'Commission': 'com' ,
                'Surcharge': 'surcharge' ,
                'Recharge Time': 'time'
            },
            headers: [
                { text: 'Recharge ID', value: 'orderno',align: 'left',sortable: false, },
                { text: 'Service', value: 'service' },
                { text: 'MobileNo', value: 'mobile' },
                { text: 'Amount', value: 'amount' },
                { text: 'Status', value: 'status' },
                { text: 'Transaction ID', value: 'tid' },
                { text: 'Type', value: 'type' },
                { text: 'Opening Balance', value: 'openbalance' },
                { text: 'Closing Balance', value: 'closebalance' },
                { text: 'Commission', value: 'com' },
                { text: 'Surcharge', value: 'surcharge' },
                { text: 'Recharge Time', value: 'time' },
                { text: 'Complain', value: 'action',align: 'center', },
                { text: 'Action', value: 'action',align: 'center', },
            ],
            report:[],
            table:[],
        }
    },
    methods:{
        checkstatus(status){
            status = status.toLowerCase();
            if(status=="success")return "success"
            if(status=="pending")return "grey"
            if(status=="in process")return "warning"
            if(status=="fail")return "error"
            return "primary"
         },
         getbackground(status){
            status = status.toLowerCase();
            if(status=="success")return "#ffff"
            if(status=="pending")return "#B0BEC5"
            if(status=="in process")return "#FFF59D"
            if(status=="fail")return "#EF9A9A"
            return "#90CAF9"
         },
         openremark(item){
            let vm = this;
            vm.tid = item.tid
            if(item.tid==null) return;
            vm.complaint=true;
         },
         handleresize(){
                 let vm = this;
                 let width = window.innerWidth-310-293+"px"
                 vm.$store.commit("setrwidth",width)
         },
         showtable(){
             let vm = this;
             vm.table = [];             
             for(let i = 0;i<vm.report.length;i++){
                 let doc = vm.report[i];
                 let data ={
                    orderno:doc.RechargeId,
                    service:doc.ServiceName,
                    mobile:doc.MobileNo,
                    status:doc.Status,
                    type:doc.RechargeType,
                    com:doc.Commission,
                    tid:doc.OperatorId,
                    amount:doc.Amount,
                    openbalance:doc.OpeningBal,
                    closebalance:doc.ClosingBal,
                    time:doc.CreatedDate.replace("/Date(","").replace(")/","")  ,
                    surcharge:doc.PersonalSurcharge,
                 }                 
                vm.table.push(data);
             }
                vm.loading = false;   
        },
        fetchstatement(){            
                let vm = this;
                if(vm.phone=="") return vm.$store.dispatch("notify",{vm:vm,message:"Please Enter Phone Number",type:"warn"})
                if(vm.phone.length!=10) return vm.$store.dispatch("notify",{vm:vm,message:"10 Digit Phone Number Required",type:"warn"})
                if(vm.user.length!=0){
                vm.loading = true
                let doc = {
                    MobileNo:vm.user.phone,
                    PinNo:vm.user.pin,
                    SearchMobileNo:vm.phone
                }
                vm.$store.dispatch("axios",{
                    url:"Inquiry",
                    data:doc
                }).then(function (res) {   
                    console.log(res.data);   
                    vm.report=[]
                    if(res.data.Data!=null){
                        vm.report = res.data.Data;
                        vm.showtable();
                    }
                    vm.loading = false         
                }).catch(function (error) {
                    console.log(error);                           
                    vm.$store.dispatch("notify",{vm:vm,message:error,type:"warn"})     
                })
                            
                }
        },
    },
    computed:{
        user(){
            return this.$store.getters.user;
        },
    },
    watch:{
    },
    mounted(){
        let vm = this;
  }
}
</script>



<style scoped>
.search{
   width:200px;
   float: right;
   height: 34px;
   background: white;
   outline:none;
   margin-left:20px;
   padding-left:10px;
   font-size:1em;
}
.searchbtn{
   margin-right:15px;
   height: 34px;
   margin-left:20px;
   float: right;
   margin-top:0px;
}

</style>
